
import { defineComponent, computed } from 'vue'
import { faCodeBranch, faCloudUploadAlt, faTimesCircle, faExclamationTriangle, faTools, faChalkboardTeacher, faBell } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  props: {
    isThemeChanged: Boolean,
    isCollapsed: Boolean
  },
  setup (props) {
    const colorTheme = computed(() => props.isThemeChanged ? 'Dark(Visual Studio)' : 'Dracula')

    const icons = computed(() => ({
      faCodeBranch,
      faCloudUploadAlt,
      faTimesCircle,
      faExclamationTriangle,
      faTools,
      faChalkboardTeacher,
      faBell
    }))

    return {
      colorTheme,
      icons
    }
  }
})
